import React , { Component } from 'react';
import PropTypes from 'prop-types';

import {injectIntl} from 'react-intl';

import {Link} from "react-router";

import { buildTabLabelFromPath, checkQueryParams } from '../../utils';

import ChartPanel from '../ChartPanel/ChartPanel';

import { chartComponentConfiguration, queryKeyOrder, selectBuilder, selectHandler, dateString, isEmpty } from './ChartComponentUtils';

import Helpable from '../Helpable';

import ChartsStore from '../../store/ChartsStore';


class TabMenu extends Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      isLoading:false,
      selectedTab:''
    }

  }


  sanitizeQueryParams(type,operation, query) {
    let res = {};
    let values = null;

    if (queryKeyOrder[type] && queryKeyOrder[type][operation]) {
      queryKeyOrder[type][operation].forEach( function(key)  {
        if (query[key]) {
          values = {[key]:query[key]};
        }
        Object.assign(res,values);
      }
    )}
    return res;
  }


  handleActiveTab(tabSelection) {
    this.setState({selectedTab:tabSelection});
  }

  componentWillMount() {
    ChartsStore.addChangeListener(this.handleChange);
  }
  componentWillUnmount() {
    ChartsStore.removeChangeListener(this.handleChange);
  }

  handleChange() {
    this.setState({isLoading:ChartsStore.isLoading()});
  }

  render() {
    const { formatMessage } = this.props.intl;

    let mainTabs = [];
    let queryParams = {};


    let selectedTab = buildTabLabelFromPath(this.props.selectionPrefix, this.props.location.pathname);
    //  let selectedSubTab = buildTabLabelFromPath('subtab', this.props.location.pathname);
    let link = null;

    this.props.tabs.forEach(function (tab, i) {
      let info =tab.link.split('/');
      let kind = info[1];
      let operation = info[2];
      let key="";
      if (chartComponentConfiguration[kind].query) {
        queryParams = this.sanitizeQueryParams(kind, operation, this.props.location.query);
        queryParams = (!isEmpty(queryParams)?queryParams:chartComponentConfiguration[kind].query);
      }

      if (this.state.isLoading) {
        link = <a style={{cursor:'wait', border:'none'}}>{formatMessage({id:tab.label})}</a>
      } else {
        link =
          <Link style={{border:'none'}}
                to={{pathname:tab.link, query:queryParams}}
                onClick={this.handleActiveTab.bind(this,tab.label)}>{formatMessage({id:tab.label})}
          </Link>
      }

      key=this.props.keyPrefix+i;
      let match = false;



        if (this.props.strictTabMatch) {
          if (selectedTab.length===tab.label.length) {
            match = selectedTab===tab.label;
          } else {
            match = (selectedTab.indexOf(tab.label+'.')>=0);
          }
        } else {
          match = (selectedTab.indexOf(tab.label)>=0);
        }


      mainTabs.push(

        <li style={{marginBottom:'3px', borderBottom:'none'}} key={key} className={(match)?'active':''}>
          {link}
        </li>
      )

    }.bind(this)
  );

  let currentGuide = this.props.kind+'Tab.guide';
  return (
    <Helpable bind={this.props.id} guideRef={currentGuide} enabled={this.props.guide}>
    <ul id={this.props.id} className={this.props.className} style={this.props.style} >
      {mainTabs}
    </ul>
    </Helpable>
  )

  }
}


class ChartComponent extends Component {

  constructor(props) {
    super(props);

    //this.handleActiveTab = this.handleActiveTab.bind(this);
    this.buildQueryParams = this.buildQueryParams.bind(this);

    let data = this.prepareAndCheckData(this.props);

    this.state = {
      queryParams:data.queryString,
      selectedTab:'',
      errors:data.errors,
      innerTabSelected: false,
      config:{
        //params: ['groupby=zone', 'start=2012-01-01', 'end='+dateString],
        params: {groupby:'zone', start:'2012-01-01', end:dateString},
        config: {},
        context:{}
      }
    }
  }



  prepareAndCheckData(props) {


    let routerCtx = props.location.pathname.split("/");

    let queryData = this.buildQueryParams(routerCtx[1],routerCtx[2], props.location.query);

    let errors = [];


    if (chartComponentConfiguration[props.params.kind].queryParams)
      errors = checkQueryParams(routerCtx[1],routerCtx[2], props.location.query, chartComponentConfiguration[props.params.kind].queryParams);

    // Nel caso in cui l'oggetto restituito non abbia elementi ma esiste un valore default possibile allore i casi sono due:
    // -1 Si ricostruisce il parametro default.
    // -2 Si genera un errore: almeno deve essere presente il parametro default.


    // 1-
    // if (Object.entries(queryData).length==0 && chartComponentConfiguration[props.route.name].query) {
    //   queryData=this.buildQueryParams(routerCtx[1],routerCtx[2],chartComponentConfiguration[props.route.name].query);
    // }

    // 2-

    if (isEmpty(queryData) && chartComponentConfiguration[props.params.kind].query) {
      errors.push({error:"missing query params"});
      //chartComponentConfiguration[props.route.name].query;
    }

    let queryString = "";

    Object.keys(queryData).forEach(function(k,i){
      queryString += (i?"&":"")+k+"="+queryData[k];
    });

    return {
      errors:errors,
      queryString:queryString
    }

  }


  componentWillReceiveProps(nextProps) {

    let data = this.prepareAndCheckData(nextProps);

    this.setState({
      queryParams:data.queryString,
      selectedTab:this.state.selectedTab,
      errors:data.errors
    });
  }


/*
  handleActiveTab(tabSelection) {
    this.setState({selectedTab:tabSelection});
  }
*/




  buildQueryParams(type, operation, query) {

    let res = {};
    let values = null;

    if (queryKeyOrder[type] && queryKeyOrder[type][operation]) {
      queryKeyOrder[type][operation].forEach( function(key)  {

        if (query[key]) {
          values = chartComponentConfiguration[type].queryParams[key][query[key]];
          Object.assign(res,values);
        }
      })
    }
    return res;
  }


  sanitizeQueryParams(type,operation, query) {
    let res = {};
    let values = null;

    if (queryKeyOrder[type] && queryKeyOrder[type][operation]) {
      queryKeyOrder[type][operation].forEach( function(key)  {
        if (query[key]) {
          values = {[key]:query[key]};
        }
        Object.assign(res,values);
      }
    )}
    return res;

  }


  render() {
    const { formatMessage } = this.props.intl;
    const { kind, type, event, period } = this.props.params;


    let query = {};

    for (var key in this.props.location.query) {
      if(this.props.location.query.hasOwnProperty(key)) {
        query[key]=this.props.location.query[key];
      }
    }

    let paramContext = {
      kind:kind,
      operation:type,
      //type: type,
      event: event,
      period:period,
      params:this.state.config.params
    };

  //  let params = this.props.location.pathname;

    let chartConf = chartComponentConfiguration[this.props.params.kind];

    let selectedSubTab = buildTabLabelFromPath('subtab', this.props.location.pathname);

    let panelTitle = formatMessage({id:this.props.params.kind+'.'+this.props.params.type+'.title'});


    let subTabs = [];


    chartConf.subtabs.forEach(function(subtab, i) {

      if ( this.state.selectedTab.indexOf(subtab.selector)>=0 || selectedSubTab.indexOf(subtab.selector)>=0 ) {

        let subTab = <TabMenu key={i} tabs={subtab.tabs} intl={this.props.intl} kind={this.props.params.kind} location={this.props.location} selectionPrefix="subtab" keyPrefix="sub" guide={false}
                              id="subTabs" className="nav nav-tabs nav-tabs-pf" strictTabMatch={true} style={{borderTop:'1px solid #ededed', borderBottom:'none'}}/>;

        subTabs.push(subTab);
      }
     }.bind(this)
    );


    let operationFilters = [];
    if (chartConf.filters) {

      chartConf.filters.forEach(function(filter,i) {
        var values = selectBuilder(this.props.params.kind+'.'+filter, paramContext.operation, this.state, query, this.props, formatMessage);
        let handler = selectHandler[this.props.params.kind+'.'+filter].bind(this);

        operationFilters.push({
          label:filter,
          onChange:handler,
          values:values
        });

      }.bind(this));
    }



    let chartTitleId = this.props.params.kind+'.charts';


    return (
      <ChartPanel paramContext={paramContext}
                  routeParams={{params:this.props.params, location:this.props.location}}
                  location={this.props.location}
                  title={panelTitle}
                  cardTitle={formatMessage({id:chartTitleId})}

                  errors={this.state.errors}
                  optionsList={operationFilters}
                  queryParams={this.state.queryParams} >


          <TabMenu tabs={chartConf.tabs} id="mainTabs" intl={this.props.intl} kind={this.props.params.kind} location={this.props.location}
                   selectionPrefix="tab" keyPrefix="tab" strictTabMatch={false}
                   className="nav nav-tabs" style={{borderBottom:'none'}}/>

          {subTabs}

      </ChartPanel>

    )
  }

}

ChartComponent.contextTypes = {
  router: PropTypes.object.isRequired
};

export default injectIntl(ChartComponent);



// WEBPACK FOOTER //
// ./src/components/charts/ChartComponent.js